/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import { AccommodationInvoiceState } from '../state/AccommodationInvoiceState'
import AccommodationInvoiceEvent from '../../event/AccommodationInvoiceEvent'

class AccommodationInvoicesStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccommodationInvoiceEvent.onSearch:
        if (!payload || !payload.invoices) {
          return state
        }

        const invoices = payload.invoices.map(invoice => new AccommodationInvoiceState(invoice))
        return List(invoices)

      default:
        return state
    }
  }
}

export default new AccommodationInvoicesStore()
